import { appName } from '../../../__config__/env.json'
import getWindow from '../../utils/get-window'

export const track = (event, label, value, nonInteractive) => {
  return getWindow().dataLayer
    ? getWindow().dataLayer.push({
        event: 'gaTriggerEvent',
        gaEventCategory: appName,
        gaEventAction: event,
        gaEventLabel: label,
        gaEventValue: value,
        gaNonInteractive: nonInteractive || 0
      })
    : console.log('gaEvent', { type: appName, action: event, label, value, nonInteractive })
}

export const datalayerPush = (data) => {
  const w = getWindow()
  w.dataLayer && w.dataLayer.push(data)
}

export const addDestinationFilterForEvents = (events) => {
  const w = getWindow()
  w.nerdEvents.addDestinationFilter(({ payload, context, destinations, skip }) => {
    if (events.includes(destinations.segment.getEventName(payload.name, payload.nerdAttributes))) {
      return [destinations.segment]
    }

    return skip()
  })
}

export const trackSegment = (event, properties) => {
  const nerdalytics = getWindow().nerdalytics

  nerdalytics && nerdalytics.track(event, properties, () => {})
}

export const sendFbTrack = () => {
  const w = getWindow()
  if (w.fbPixel) {
    w.fbPixel.init()
    w.fbPixel.track('ViewContent', { content_category: 'broadband', content_name: 'broadband' })
  }
}

export const hasAcceptedMarketing = () => {
  const w = getWindow()
  if (!w.uSwitch.cookie.read('cookie-preferences')) return false
  const cookieConsent = JSON.parse(w.uSwitch.cookie.read('cookie-preferences') || '')
  return cookieConsent.marketing || cookieConsent.social
}

export const sendFbClick = () => {
  const w = getWindow()
  w.fbPixel && w.fbPixel.track('Lead', { content_category: 'broadband', content_name: 'broadband' })
}

export const sendFbSearch = () => {
  const w = getWindow()
  w.fbPixel && w.fbPixel.track('Search', { content_category: 'broadband', content_name: 'broadband' })
}

export const trackExperiments = (experiences) => {
  Object.entries(experiences).forEach(([experiment, { cohort, iteration }]) => {
    track('Experience Bucket', `${experiment}:${cohort}`, null, true)

    if (!/^experiment/.test(experiment)) {
      return // if not experiment do nothing
    }

    const segmentObject = { experiment_id: experiment, iteration_id: iteration, variation_id: `${cohort}` }

    trackSegment('Experiment Loaded', segmentObject)

    if (experiment === 'experiment-partytown' && cohort !== 1) {
      // in control do nothing as experiment is tracked using track()
    }
  })
}
